import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import db from '../services/db';
import EnrollContactLinks from '../components/EnrollContactLinks';

const HomePage = () => {
    const [siteText, setSiteText] = useState([]);
    useEffect(() => {
        const load = async () => {
            const data = await db.getTable('siteText');
            setSiteText(data);
        };
        load();
    }, []);

    const getText = (key, defaultVal) => {
        const item = siteText.find(t => t.key === key);
        return item ? item.content : defaultVal;
    };
    return (
        <div className="home-page">
            {/* Hero Section */}
            <section className="hero-section text-center">
                <div className="container flex items-center justify-center gap-12" style={{ paddingTop: '6rem', paddingBottom: '6rem', flexWrap: 'wrap' }}>
                    <div className="hero-content animate-fade-in mx-auto" style={{ flex: '1 1 500px', maxWidth: '800px' }}>
                        <h1 className="font-header main-title mb-6 text-gray-900">
                            {getText('home_hero_title', 'Английский в удовольствие.')}
                        </h1>

                        <div className="description text-lg mb-8 text-secondary mx-auto" style={{ lineHeight: '1.8' }}>
                            <p style={{ marginBottom: '1rem', fontWeight: '500', color: '#1e293b', fontSize: '1.25rem' }}>
                                {getText('home_bio_title', 'Кто я?')}
                            </p>
                            <div dangerouslySetInnerHTML={{ __html: getText('home_bio_text', '') }} />
                        </div>
                        <div className="flex gap-4" style={{ justifyContent: 'center' }}>
                            <EnrollContactLinks getText={getText} />
                        </div>
                    </div>
                </div>
            </section>

            {/* Methodology Section */}
            <section className="method-section" style={{ backgroundColor: 'var(--bg-secondary)', padding: '6rem 0' }}>
                <div className="container">
                    <div className="section-header text-center mb-16 animate-fade-in">
                        <h2 className="font-header text-4xl mb-4">{getText('home_method_title', 'Моя методика')}</h2>
                        <p className="max-w-2xl mx-auto text-lg pt-4 pb-8" style={{ color: '#64748b' }}>
                            {getText('home_method_subtitle', 'Многие школы учат языку ради языка. Я учу языку ради удовольствия и цели.')}
                        </p>
                    </div>

                    <div className="method-grid gap-8">
                        <div className="method-card card glass animate-fade-in" style={{ animationDelay: '0.1s' }}>
                            <div className="icon">💬</div>
                            <h3 className="font-header text-xl mb-3">{getText('home_method_1_title', 'Коммуникативный подход')}</h3>
                            <div className="text-secondary text-base" dangerouslySetInnerHTML={{ __html: getText('home_method_1_text', '') }} />
                        </div>
                        <div className="method-card card glass animate-fade-in" style={{ animationDelay: '0.2s' }}>
                            <div className="icon">🧠</div>
                            <h3 className="font-header text-xl mb-3">{getText('home_method_2_title', 'Минимум сложных правил')}</h3>
                            <div className="text-secondary text-base" dangerouslySetInnerHTML={{ __html: getText('home_method_2_text', '') }} />
                        </div>
                        <div className="method-card card glass animate-fade-in" style={{ animationDelay: '0.3s' }}>
                            <div className="icon">🎯</div>
                            <h3 className="font-header text-xl mb-3">{getText('home_method_3_title', 'Индивидуальная траектория')}</h3>
                            <div className="text-secondary text-base" dangerouslySetInnerHTML={{ __html: getText('home_method_3_text', '') }} />
                        </div>
                    </div>
                </div>
            </section>

            {/* Why Students Stay Section */}
            <section className="why-stay-section" style={{ padding: '6rem 0' }}>
                <div className="container">
                    <div className="section-header text-center mb-16 animate-fade-in">
                        <h2 className="font-header text-4xl mb-4">{getText('home_why_title', 'Почему студенты приходят ко мне и остаются?')}</h2>
                    </div>

                    <div className="method-grid gap-8">
                        <div className="method-card card glass animate-fade-in" style={{ animationDelay: '0.1s' }}>
                            <div className="icon">🗣️</div>
                            <h3 className="font-header text-xl mb-3">{getText('home_why_1_title', 'Разговор с первого занятия')}</h3>
                            <div className="text-secondary text-base" dangerouslySetInnerHTML={{ __html: getText('home_why_1_text', '') }} />
                        </div>
                        <div className="method-card card glass animate-fade-in" style={{ animationDelay: '0.2s' }}>
                            <div className="icon">☕</div>
                            <h3 className="font-header text-xl mb-3">{getText('home_why_2_title', 'Атмосфера')}</h3>
                            <div className="text-secondary text-base" dangerouslySetInnerHTML={{ __html: getText('home_why_2_text', '') }} />
                        </div>
                        <div className="method-card card glass animate-fade-in" style={{ animationDelay: '0.3s' }}>
                            <div className="icon">🤝</div>
                            <h3 className="font-header text-xl mb-3">{getText('home_why_3_title', 'Честность')}</h3>
                            <div className="text-secondary text-base" dangerouslySetInnerHTML={{ __html: getText('home_why_3_text', '') }} />
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="cta-section" style={{ padding: '8rem 0', backgroundColor: 'var(--bg-secondary)', textAlign: 'center' }}>
                <div className="container max-w-4xl mx-auto">
                    <h2 className="font-header text-5xl mb-6 animate-fade-in" style={{ color: '#1e293b', lineHeight: '1.2' }}>{getText('home_cta_title', 'Приходи на пробный урок')}</h2>
                    <div className="text-secondary text-xl mb-12 animate-fade-in" style={{ animationDelay: '0.1s', lineHeight: '1.6' }} dangerouslySetInnerHTML={{ __html: getText('home_cta_text', '') }} />
                    <div className="animate-fade-in" style={{ animationDelay: '0.2s', display: 'flex', justifyContent: 'center' }}>
                        <EnrollContactLinks getText={getText} />
                    </div>
                </div>
            </section>

            <style dangerouslySetInnerHTML={{
                __html: `
                .home-page { overflow-x: hidden; }
                .main-title { font-size: 3.5rem; font-weight: 800; line-height: 1.15; letter-spacing: -0.02em; }
                .text-gray-900 { color: #0f172a; }
                
                .hero-section { background: radial-gradient(circle at 100% 0%, rgba(67, 97, 238, 0.05) 0%, transparent 40%); }
                .main-portrait { width: 100%; border-radius: 20px; border: 1px solid var(--border-color); object-fit: cover; aspect-ratio: 4/5; }
                .image-wrapper { position: relative; }
                
                .glass { background: rgba(255, 255, 255, 0.7); backdrop-filter: blur(10px); }
                .method-card { padding: 40px; transition: transform 0.3s ease; height: 100%; border-radius: 24px; box-shadow: 0 10px 25px -5px rgba(0,0,0,0.03), 0 8px 10px -6px rgba(0,0,0,0.01); border: 1px solid rgba(0,0,0,0.06); }
                .method-card:hover { transform: translateY(-8px); box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04); border-color: rgba(67, 97, 238, 0.2); }
                .method-card .icon { font-size: 48px; margin-bottom: 24px; display: inline-block; }
                .method-card h3 { font-size: 1.4rem; font-weight: 800; color: #1e293b; margin-bottom: 1rem;}
                .method-card p { font-size: 1.05rem; line-height: 1.7; color: #475569; margin: 0; }
                
                .method-grid { display: grid; grid-template-columns: 1fr; gap: 2rem; }
                
                .mx-auto { margin-left: auto; margin-right: auto; }
                .text-4xl { font-size: 2.5rem; font-weight: 800; color: #1e293b; }
                .text-5xl { font-size: 3.2rem; font-weight: 800; letter-spacing: -0.02em; }
                .text-xl { font-size: 1.25rem; }
                .text-base { font-size: 1rem; }
                .mb-3 { margin-bottom: 0.75rem; }
                .mb-4 { margin-bottom: 1rem; }
                .mb-6 { margin-bottom: 1.5rem; }
                .mb-8 { margin-bottom: 2rem; }
                .mb-12 { margin-bottom: 3rem; }
                .mb-16 { margin-bottom: 4rem; }
                .pt-4 { padding-top: 1rem; }
                .pb-8 { padding-bottom: 2rem; }
                .text-center { text-align: center; }

                .enroll-btn {
                    background: linear-gradient(135deg, #10b981, #059669);
                    color: white;
                    font-weight: 800;
                    font-size: 1.35rem;
                    padding: 1.25rem 3.5rem;
                    border-radius: 50px;
                    box-shadow: 0 10px 20px -5px rgba(16, 185, 129, 0.4);
                    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                    text-decoration: none;
                    animation: pulse-green 2s infinite cubic-bezier(0.4, 0, 0.6, 1);
                    display: inline-block;
                }

                @keyframes pulse-green {
                    0%, 100% {
                        opacity: 1;
                        transform: scale(1);
                        box-shadow: 0 10px 20px -5px rgba(16, 185, 129, 0.4);
                    }
                    50% {
                        opacity: .95;
                        transform: scale(1.03);
                        box-shadow: 0 15px 25px -5px rgba(16, 185, 129, 0.6);
                    }
                }

                .enroll-btn:hover {
                    box-shadow: 0 15px 30px -5px rgba(16, 185, 129, 0.5);
                    transform: translateY(-4px) scale(1.05);
                    animation: none;
                }

                @media (min-width: 768px) {
                    .method-grid { grid-template-columns: repeat(3, 1fr); align-items: stretch; }
                }

                @media (max-width: 768px) {
                    .main-title { font-size: 2.2rem; }
                    .hero-section .container { flex-direction: column-reverse; padding-top: 3rem; }
                }
            `}} />
        </div>
    );
};

export default HomePage;
